/**
 * This library is the only place where you'd use raw analytics from atlaskit
 */

import { Component } from 'react';
import { withAnalyticsEvents, type AnalyticsEvent } from '@atlaskit/analytics-next';

type Props = {
	// this prop is coming from Atlaskit, no control over it
	createAnalyticsEvent: (arg1: { action: string }) => AnalyticsEvent;
	onMount: (arg1: AnalyticsEvent) => void;
};

// eslint-disable-next-line jira/react/no-class-components
class MountEventComponent extends Component<Props> {
	componentDidMount() {
		const analyticsEvent = this.props.createAnalyticsEvent({ action: 'mounted' });
		if (this.props.onMount) {
			this.props.onMount(analyticsEvent);
		}
	}

	render() {
		return null;
	}
}

// @ts-expect-error - TS2345 - Argument of type 'typeof MountEventComponent' is not assignable to parameter of type '(((props: WithAnalyticsEventsProps) => ReactElement<any, string | ((props: any) => ReactElement<any, any> | null) | (new (props: any) => Component<any, any, any>)> | null) & typeof MountEventComponent) | ((new (props: WithAnalyticsEventsProps) => Component<...>) & typeof MountEventComponent)'.
export const MountEvent = withAnalyticsEvents()(MountEventComponent);
